/** @jsxImportSource @emotion/react */
"use client";
import type { Interpolation } from "@emotion/react";
import type { ForYouPostPrayer } from "@packages/sdk";
import type { MouseEventHandler } from "react";

import { numericPercentages, spacing } from "../../../../../../global/emotion";
import { RecommendationDeeplink } from "../../../../../components/blocks/other/RecommendationDeeplink/RecommendationDeeplink.emotion";
import { cssMediaQueryMinWidthTablet } from "../../../../../lib/constants/emotionMediaQueries.constants";

const containerStyle: Interpolation = {
  display: "flex",
  flexDirection: "column",
  rowGap: spacing.s,
  width: spacing.full,
  [cssMediaQueryMinWidthTablet]: { width: numericPercentages[90] },
};

export const PostPrayerRecommendationButton = ({
  step,
  onClick,
}: {
  step: ForYouPostPrayer;
  onClick?: MouseEventHandler<any>;
}) => (
  <div css={containerStyle}>
    {step.recommendations.map((rec, idx) => (
      <RecommendationDeeplink
        key={`rec.${rec.id}.${idx}`}
        {...rec}
        onClick={onClick}
      />
    ))}
  </div>
);
